<template>
  <div>
    <!-- 저장하기 버튼 -->
    <div class="btn-group-justify-end">
      <button class="button is-primary" @click="save">저장하기</button>
    </div>

    <div v-if="value">
      <div class="columns is-multiline">

        <!-- 내부 플러그인 관리 -->
        <div class="column is-8">
          <div class="box">
            <div class="column is-full">
              <admin-form-item label="정산 기준 설정" desc="정산예정 메뉴에서 정산하기의 기준을 설정합니다.">
                <lp-radio :val.sync="value.is_account"
                          value_name="value"
                          label_name="label"
                          :data="[{label:'사용',value:true}, {label:'미사용', value:false}]"></lp-radio>
              </admin-form-item>
            </div>

            <div class="column is-full" v-if="value.is_account">
              <admin-form-item label="정산 방법">
                <lp-radio :val.sync="value.account_type"
                          value_name="value"
                          label_name="label"
                          :disabled="!isAdmin"
                          :data="[{label:'날짜', value:0}, {label:'금액', value:1}]"></lp-radio>
              </admin-form-item>

              <!-- 날짜 지정 -->
              <admin-form-item label="날짜"
                               desc="정산예정에 목록이 추가될 경우에 예상날짜를 반영합니다."
                               v-if="value.account_type===0">
                <input class="input"
                       style="width:250px"
                       :value="value.account_day"
                       @input="inputAccountDay"
                       :disabled="!isAdmin"
                       type="number">
              </admin-form-item>

              <!-- 이상 금액 지정 -->
              <admin-form-item label="금액"
                               desc="지정한 금액이상이 됐을 경우 정산완료를 할 수 있습니다."
                               v-if="value.account_type===1">
                <input class="input"
                       style="width:250px"
                       :value="value.account_price"
                       @input="e=> value.account_price = e.target.value"
                       :disabled="!isAdmin"
                       type="number">
              </admin-form-item>

              <admin-form-item label="정산 공제 항목 설정">
                <div>
                  <lp-check-bool :checked-val.sync="value.is_comm"
                                 label="상품 거래 기본 수수료 설정"></lp-check-bool>
                </div>
                <div class="flex align-center" style="margin-bottom:12px" v-if="value.is_comm">
                  <span>상품 주문 합계액의</span>
                  <span style="margin:0 4px">
                    <input class="input full has-text-right"
                           v-model="value.comm_rate"
                           @input="e => setFloat(e, 'comm_rate', 4)"
                           :disabled="!isAdmin"
                           step="0.1"
                           type="number"
                           v-if="value.comm_type===0">
                    <input class="input full has-text-right"
                           v-model="value.comm_price"
                           @input="e => setNumber(e, 'comm_price', 10)"
                           :disabled="!isAdmin"
                           type="number"
                           v-if="value.comm_type===1">
                  </span>
                  <span class="select">
                    <select v-model="value.comm_type"
                            @change="e => value.comm_type = parseInt(e.target.value)">
                      <option :value="0">%</option>
                      <option :value="1">원</option>
                    </select>
                  </span>
                  <span style="margin-left:4px">공제 후 정산</span>
                </div>
                <div>
                  <lp-check-bool :checked-val.sync="value.is_point"
                                 label="적립금 공제"></lp-check-bool>
                </div>
                <div class="flex align-center" v-if="value.is_point">
                  <span>구매자에게 적립되는 포인트의</span>
                  <span style="margin:0 4px">
                    <input class="input full has-text-right"
                           v-model="value.point_rate"
                           @input="e => setFloat(e, 'point_rate', 4)"
                           :disabled="!isAdmin"
                           step="0.1"
                           type="number"
                           v-if="value.point_type===0">
                    <input class="input full has-text-right"
                           v-model="value.point_price"
                           @input="e => setNumber(e, 'point_price', 10)"
                           :disabled="!isAdmin"
                           type="number"
                           v-if="value.point_type===1">
                  </span>
                  <span class="select">
                    <select v-model="value.point_type"
                            @change="e => value.point_type = parseInt(e.target.value)">
                      <option :value="0">%</option>
                      <option :value="1">원</option>
                    </select>
                  </span>
                  <span style="margin-left:4px">공제 후 정산</span>
                </div>
              </admin-form-item>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import LpRadio from "../../../module/common/LpRadio";
  import LpCheckBool from "../../../module/common/LpCheckBool";

  export default {
    components: {LpRadio, LpCheckBool},
    data() {
      return {
        value: null,
        /*is_account: false,
          account_type: 0,
          account_datetime: '',
          account_price: 0*/
      }
    },
    created() {
      this.$axios.get('admin/commerce/account/setting').then(res=>{
        this.value = res.data;
        if(this.value.account_day===0) {
          this.value.account_day = 1;
        }
      })
    },
    methods: {
      inputAccountDay(e) {
        let value = parseInt(e.target.value);
        if(value<1) value=1;
        else if(value > 30) value = 30;
        this.value.account_day = value;
      },
      setFloat(e, attr, max_length){
        let max = 100;
        let min = 0;
        let val = parseFloat(e.target.value.substr(0,max_length));
        if(max<val) val = max;
        if(val<min) val= min;
        this.value[attr] =  val;
      },
      setNumber(e, attr, max_length){
        this.value[attr] = parseInt(e.target.value.substr(0,max_length));
      },
      save() {
        this.$axios.patch('admin/commerce/account/setting', {
          account_setting: this.value
        }).then(res=>{
          if(res.status===200) this.toast('저장되었습니다.');
        })
      }
    }
  }
</script>

<style lang="stylus" type="stylus" scoped>
  @import '~assets/css/lp_main'
</style>
